import PropTypes from 'prop-types'

import LessonEditor from './LessonEditor'
import QuizEditor from './QuizEditor'
import PublishChecklist from './PublishChecklist'

import classes from './EditorPanel.module.scss'

const EditorPanel = ({ certification, selection, onSelect }) => {
  const section = selection?.sectionId && certification.sections.find(current => current.id === selection.sectionId)
  const sectionNumber = section ? certification.sections.indexOf(section) + 1 : null
  const lesson = selection?.type === 'lesson' && section?.lessons.find(current => current.id === selection.id)
  const quiz = selection?.type === 'quiz' ? section?.quiz : selection?.type === 'finalQuiz' ? certification.finalQuiz : null

  if (!lesson && !quiz) { return <PublishChecklist certification={certification} /> }

  return (
    <aside className={classes.panel}>
      {lesson ? (
        <LessonEditor
          key={lesson.id}
          lesson={lesson}
          sectionNumber={sectionNumber}
          lessonNumber={section.lessons.indexOf(lesson) + 1}
          onDeleted={() => onSelect(null)}
        />
      ) : (
        <QuizEditor key={quiz.id} certificationId={certification.id} quiz={quiz} sectionNumber={sectionNumber} onDeleted={() => onSelect(null)} />
      )}
    </aside>
  )
}

EditorPanel.propTypes = {
  certification: PropTypes.shape({
    id: PropTypes.number.isRequired,
    sections: PropTypes.array.isRequired,
    finalQuiz: PropTypes.object.isRequired,
  }).isRequired,
  selection: PropTypes.shape({
    type: PropTypes.string.isRequired,
    id: PropTypes.number,
    sectionId: PropTypes.number,
  }),
  onSelect: PropTypes.func.isRequired,
}

export default EditorPanel
